import { zipSync, strToU8 } from "fflate";

export const csvCell = (v: unknown) => `"${String(v ?? "").replace(/"/g, '""')}"`;
export const toCsv = (head: string[], rows: unknown[][]) =>
  [head.map(csvCell).join(","), ...rows.map((r) => r.map(csvCell).join(","))].join("\n");

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Bundles the report files into a single ZIP that can be shared with trustees. */
export function downloadZip(files: Record<string, string>, filename: string) {
  const entries: Record<string, Uint8Array> = {};
  for (const [name, content] of Object.entries(files)) {entries[name] = strToU8(content);}
  const zipped = zipSync(entries, { level: 6 });
  const buffer = new ArrayBuffer(zipped.byteLength);
  new Uint8Array(buffer).set(zipped);
  downloadBlob(new Blob([buffer], { type: "application/zip" }), filename);
}
